import { useLayoutEffect, useState } from 'react';

/**
 * Check if an element is overflowing.
 * Useful if styles need to be applied when overflowing.
 *
 * - observes resize events to stay up to date
 * - cleans up after it self
 */
export default function useIsOverflow(ref: React.RefObject<HTMLElement>): boolean {
  const [isOverflow, setIsOverflow] = useState(false);

  useLayoutEffect(() => {
    const { current } = ref;

    function trigger(): void {
      if (!current) return;
      const hasOverflow = current.scrollHeight > current.clientHeight;
      setIsOverflow(hasOverflow);
    }

    const observer = new ResizeObserver(trigger);
    trigger();

    if (current) observer.observe(current);

    return (): void => observer.disconnect();
  }, [ref]);

  return isOverflow;
}
